import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=b33377ba&scoped=true&"
import script from "./ActivityDetail.vue?vue&type=script&lang=js&"
export * from "./ActivityDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=b33377ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33377ba",
  null
  
)

export default component.exports